/* aaa-pdp.js — behaviour for snippets/aaa-product.liquid.
 *
 * The theme (assets/colors.js, Colors.Product) still owns variant selection,
 * prices, add-to-cart state and media show/hide. This file only adds what the
 * new layout needs on top, and never replaces a theme handler:
 *   - stage arrows, keyboard, counter and the active thumbnail
 *   - mobile: show the variant's image when the variant changes (the theme
 *     only re-orders media when the thumb strip is hidden)
 *   - selected option value next to its label, SKU, "Save $x"
 *   - quantity stepper
 *   - in-page links, description "read more"
 *   - mobile sticky add-to-cart appears once the real button has scrolled up out of view
 */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents) {
    try {
      if (window.Colors && Colors.Currency && Colors.strings && Colors.strings.money_format) {
        return Colors.Currency.formatMoney(cents, Colors.strings.money_format);
      }
    } catch (e) {}
    return '$' + (cents / 100).toFixed(2);
  }

  function handleize(s) {
    return String(s).toLowerCase().replace(/['"]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function initSection(section) {
    if (!section || section.dataset.aaaBound === '1') return;
    if (!section.classList.contains('aaa-pdp')) return;
    section.dataset.aaaBound = '1';

    /* ---------------- gallery ---------------- */
    var media = section.querySelector('[data-aaa-media]');
    var wrappers = media ? Array.prototype.slice.call(media.querySelectorAll('[data-product-single-media-wrapper]')) : [];
    var countEl = section.querySelector('[data-aaa-count-current]');
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-aaa-thumb]'));
    var rail = section.querySelector('.aaa-thumbs');

    function currentIndex() {
      for (var i = 0; i < wrappers.length; i++) {
        if (!wrappers[i].classList.contains('hide')) return i;
      }
      return 0;
    }

    function show(target) {
      if (wrappers.length < 2) return;
      var n = wrappers.length;
      target = ((target % n) + n) % n;
      var cur = currentIndex();
      if (target === cur) return;
      if (window.jQuery) {
        jQuery(wrappers[cur]).addClass('hide').trigger('mediaHidden');
        jQuery(wrappers[target]).removeClass('hide').trigger('mediaVisible');
      } else {
        wrappers[cur].classList.add('hide');
        wrappers[target].classList.remove('hide');
      }
    }

    /* phone: dots under the photo say "there is more, swipe" */
    var dots = null;
    if (media && wrappers.length > 1) {
      dots = document.createElement('div');
      dots.className = 'aaa-dots';
      dots.setAttribute('aria-hidden', 'true');
      for (var di = 0; di < Math.min(wrappers.length, 10); di++) {
        (function (k) {
          var d = document.createElement('span');
          d.className = 'aaa-dots__dot';
          d.addEventListener('click', function () { show(k); });
          dots.appendChild(d);
        })(di);
      }
      var stg = media.querySelector('.aaa-stage');
      if (stg) stg.insertAdjacentElement('afterend', dots);
    }

    function sync() {
      var idx = currentIndex();
      var active = wrappers[idx];
      if (countEl) countEl.textContent = String(idx + 1);
      if (dots) Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-on', i === Math.min(idx, dots.children.length - 1)); });
      if (!active) return;
      var id = active.id;
      thumbs.forEach(function (t) {
        var on = t.getAttribute('data-aaa-thumb') === id;
        t.parentNode.classList.toggle('is-active', on);
        if (on) {
          t.setAttribute('aria-current', 'true');
          if (rail && rail.scrollHeight > rail.clientHeight) {
            var top = t.parentNode.offsetTop - rail.offsetTop;
            if (top < rail.scrollTop || top + t.offsetHeight > rail.scrollTop + rail.clientHeight) {
              rail.scrollTo({ top: Math.max(0, top - 20), behavior: reduceMotion ? 'auto' : 'smooth' });
            }
          }
        } else {
          t.removeAttribute('aria-current');
        }
      });
    }

    if (wrappers.length) {
      var obs = new MutationObserver(sync);
      wrappers.forEach(function (w) { obs.observe(w, { attributes: true, attributeFilter: ['class'] }); });
      // The theme re-orders wrappers on mobile variant change; keep our list in DOM order.
      if (wrappers[0] && wrappers[0].parentNode) {
        new MutationObserver(function () {
          wrappers = Array.prototype.slice.call(media.querySelectorAll('[data-product-single-media-wrapper]'));
          sync();
        }).observe(wrappers[0].parentNode, { childList: true });
      }
      sync();
    }

    var prev = section.querySelector('.aaa-stage__arrow.product-media-arrow--prev');
    var next = section.querySelector('.aaa-stage__arrow.product-media-arrow--next');
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); show(currentIndex() - 1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); show(currentIndex() + 1); });
    var stage = section.querySelector('.aaa-stage');
    if (stage && wrappers.length > 1) {
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); show(currentIndex() - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); show(currentIndex() + 1); }
      });
    }

    /* ---------------- variant follow-ups ---------------- */
    var form = section.querySelector('form[action*="/cart/add"]');
    var variants = (window.product && window.product.variants) || [];
    var options = (window.product && window.product.options) || [];

    function selectedVariant() {
      if (!form) return null;
      var input = form.querySelector('[name="id"]');
      if (!input || !input.value) return null;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(input.value)) return variants[i];
      }
      return null;
    }

    var lastVariantId = null;
    function onVariant() {
      var v = selectedVariant();
      if (!v || v.id === lastVariantId) return;
      lastVariantId = v.id;

      // option values beside their labels
      options.forEach(function (name, i) {
        var el = section.querySelector('[data-aaa-opt-value="' + handleize(name) + '"]');
        if (el && v.options && v.options[i] != null) el.textContent = v.options[i];
      });

      var sku = section.querySelector('[data-aaa-sku]');
      if (sku) {
        sku.textContent = v.sku || '';
        sku.parentNode.style.display = v.sku ? '' : 'none';
      }

      var save = section.querySelector('[data-aaa-save]');
      if (save) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          save.textContent = 'Save ' + money(v.compare_at_price - v.price);
          save.classList.remove('hide');
        } else {
          save.classList.add('hide');
        }
      }

      // Variant image: on desktop the theme swaps it; on mobile it only re-orders.
      if (v.featured_media && v.featured_media.id) {
        var target = section.querySelector('[data-product-single-media-wrapper][id="' + v.featured_media.id + '"]');
        // desktop photo grid: the variant's photo becomes the lead tile
        if (target && media && media.classList.contains('aaa-media--grid') && window.matchMedia('(min-width: 990px)').matches && target.parentNode && target.parentNode.firstElementChild !== target) {
          target.parentNode.insertBefore(target, target.parentNode.firstElementChild);
        }
        if (target && target.classList.contains('hide')) {
          var idx = wrappers.indexOf(target);
          if (idx > -1) show(idx);
        }
      }
    }
    /* ---------------- variant controller ----------------
     * snippets/javascript.liquid has the theme's colors.js commented out
     * ("TEMPORARILY DISABLED THEME JS"), so on the standard dropdown/radio
     * picker nothing used to copy the shopper's choice into the form's
     * select[name="id"]: the options looked live but every add-to-cart sent
     * the first variant. This does that job for the standard picker only
     * (the Haven picker has its own script). It sets the select and fires
     * `change` on it, which is what pre-order.js, mobile-sticky-atc.js and
     * the stock-status card already listen for.
     */
    var sid = section.getAttribute('data-section-id');
    var idSelect = sid ? document.getElementById('productSelect-' + sid) : null;
    var isHaven = !!section.querySelector('.haven-variant-selectors:not(.haven-variant-quick-mobile)');
    var atcBtn = sid ? document.getElementById('addToCart-' + sid) : null;
    var atcLabel = atcBtn ? atcBtn.querySelector('span') : null;
    // The label an in-stock variant should carry: whatever Liquid rendered
    // ("Add to cart", or "Pre-order" on the pre-order template) unless the
    // first variant was itself a backorder, whose label says nothing about the rest.
    var initV = selectedVariant();
    var initBackorder = initV && window.product && window.product.backorder && window.product.backorder[initV.id];
    var availLabel = (atcLabel && !atcBtn.disabled && !initBackorder) ? atcLabel.textContent.trim() : 'Add to cart';

    function formatMoney(cents) {
      var fmt = (window.product && window.product.money_format) || '${{amount}}';
      var n = (cents / 100);
      var withDec = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var noDec = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
                .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDec.replace('.', ','))
                .replace(/\{\{\s*amount\s*\}\}/, withDec);
    }
    money = function (c) { return formatMoney(c); };

    function optionInputs() {
      return sid ? Array.prototype.slice.call(section.getElementsByClassName('single-option-selector-' + sid)) : [];
    }
    function chosenVariant() {
      var picks = [];
      optionInputs().forEach(function (el) {
        if (el.type === 'radio' && !el.checked) return;
        picks.push({ index: el.getAttribute('data-index'), value: el.value });
      });
      if (!picks.length) return null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < picks.length; j++) { if (v[picks[j].index] !== picks[j].value) { ok = false; break; } }
        if (ok) return v;
      }
      return undefined; // a combination that doesn't exist
    }
    function setAtc(enabled, label) {
      if (!atcBtn) return;
      atcBtn.disabled = !enabled;
      if (enabled) atcBtn.setAttribute('data-action', 'add-to-cart'); else atcBtn.removeAttribute('data-action');
      if (atcLabel) atcLabel.textContent = label;
    }
    function applyVariant(v) {
      if (v === null) return;
      if (!v) {
        // nothing buyable at all reads as sold out, not as a broken picker
        var anyAvail = variants.some(function (x) { return x.available; });
        setAtc(false, anyAvail ? 'Unavailable' : 'Sold out');
        return;
      }
      var backorder = window.product && window.product.backorder && window.product.backorder[v.id];
      if (idSelect) {
        var opt = idSelect.querySelector('option[value="' + v.id + '"]');
        if (!opt) {
          opt = document.createElement('option');
          opt.value = v.id;
          opt.textContent = v.title;
          idSelect.appendChild(opt);
        }
        if (String(idSelect.value) !== String(v.id)) {
          idSelect.value = String(v.id);
          idSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      var priceEl = document.getElementById('productPrice-' + sid);
      var compareEl = document.getElementById('comparePrice-' + sid);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (priceEl) {
        priceEl.innerHTML = '<span class="money">' + formatMoney(v.price) + '</span>';
        priceEl.classList.toggle('on-sale', !!onSale);
      }
      if (compareEl) compareEl.innerHTML = onSale ? '<span class="money">' + formatMoney(v.compare_at_price) + '</span>' : '';
      if (backorder) setAtc(true, 'Pre-order');
      else if (v.available) setAtc(true, availLabel);
      else setAtc(false, 'Sold out');
      try {
        var url = new URL(location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', url.toString());
      } catch (e) {}
      onVariant();
      document.dispatchEvent(new CustomEvent('aaa:variant', { detail: { variant: v } }));
    }
    if (!isHaven && idSelect && variants.length > 1) {
      section.addEventListener('change', function (e) {
        if (e.target && e.target.classList && e.target.classList.contains('single-option-selector-' + sid)) {
          applyVariant(chosenVariant());
        }
      });
      // a ?variant= deep link: reflect it in the pickers + price once
      var initial = chosenVariant();
      if (initial && String(initial.id) !== String(idSelect.value)) applyVariant(initial);
    }

    /* Haven picker: it prints the price without a thousands comma (2799.50)
       and leaves the URL on the old variant. Re-print it the way the page
       does and keep ?variant= in step, so a shared link opens this variant. */
    if (isHaven) {
      section.addEventListener('variant:changed', function (e) {
        var v = e.detail && e.detail.variant;
        if (!v) return;
        var pe = document.querySelector('#productPrice-' + sid + ' .money');
        if (pe) pe.innerHTML = formatMoney(v.price);
        var ce = document.querySelector('#comparePrice-' + sid + ' .money');
        if (ce && v.compare_at_price > v.price) ce.innerHTML = formatMoney(v.compare_at_price);
        try {
          var u = new URL(location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState(history.state, '', u.toString());
        } catch (err) {}
      });
    }

    /* thumbnail click (was colors.js initMediaGallery) */
    if (media) {
      media.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('[data-action="show-product-media"]');
        if (!a) return;
        e.preventDefault();
        var mid = a.getAttribute('data-aaa-thumb') || String(a.getAttribute('data-id') || '').split('-').pop();
        var t = media.querySelector('[data-product-single-media-wrapper][id="' + mid + '"]');
        var i = wrappers.indexOf(t);
        if (i > -1) show(i);
      });
    }

    if (form) {
      form.addEventListener('change', function () { setTimeout(onVariant, 60); });
      var idInput = form.querySelector('[name="id"]');
      if (idInput) new MutationObserver(function () { setTimeout(onVariant, 30); }).observe(idInput, { attributes: true, attributeFilter: ['value'] });
      document.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.haven-option-button, .standard-color-quick-picker button, [data-option-value]')) setTimeout(onVariant, 80);
      });
      lastVariantId = (selectedVariant() || {}).id || null;
    }

    /* ---------------- quantity ---------------- */
    var qty = section.querySelector('[data-aaa-qty]');
    if (qty) {
      var input = qty.querySelector('input');
      var minus = qty.querySelector('[data-aaa-qty-step="-1"]');
      function clamp() {
        var n = parseInt(input.value, 10);
        if (isNaN(n) || n < 1) n = 1;
        if (n > 99) n = 99;
        input.value = n;
        if (minus) minus.disabled = n <= 1;
      }
      qty.addEventListener('click', function (e) {
        var b = e.target.closest('[data-aaa-qty-step]');
        if (!b) return;
        e.preventDefault();
        input.value = (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-aaa-qty-step'), 10);
        clamp();
      });
      input.addEventListener('change', clamp);
      clamp();
    }

    /* ---------------- description read-more ---------------- */
    /* the shorter details column rides along beside the longer one */
    var balance = function () {
      var p = section.querySelector('.aaa-details__primary');
      var q = section.querySelector('.aaa-details__secondary');
      if (!p || !q) return;
      p.classList.remove('is-riding'); q.classList.remove('is-riding');
      if (window.innerWidth < 990) return;
      var short = p.offsetHeight < q.offsetHeight ? p : q;
      var long = short === p ? q : p;
      if (long.offsetHeight - short.offsetHeight > 160 && short.offsetHeight < window.innerHeight - 140) short.classList.add('is-riding');
    };
    /* ---------------- key features: said once, short on a phone ----------------
       Supplier descriptions often repeat the "Key Features" list the page
       already shows under the gallery. When that panel exists, the copy in
       the overview goes. On a phone the panel shows five, then a toggle. */
    var hl = section.querySelector('.aaa-highlights');
    if (hl) {
      Array.prototype.forEach.call(section.querySelectorAll('[data-aaa-clamp]'), function (pr) {
        Array.prototype.slice.call(pr.querySelectorAll('h2,h3,h4,h5,h6,p,strong,b')).forEach(function (h) {
          if (!/^\s*key\s+features\s*:?\s*$/i.test(h.textContent)) return;
          var blk = h;
          while (blk.parentElement && blk.parentElement !== pr && blk.parentElement.textContent.trim() === h.textContent.trim()) blk = blk.parentElement;
          var next = blk.nextElementSibling;
          if (next && /^(UL|OL)$/.test(next.tagName)) { next.remove(); blk.remove(); }
        });
      });
      var hlItems = hl.querySelectorAll('.aaa-features li');
      if (hlItems.length > 6) {
        hl.classList.add('is-short');
        var hlBtn = document.createElement('button');
        hlBtn.type = 'button'; hlBtn.className = 'aaa-more aaa-hl-more'; hlBtn.setAttribute('aria-expanded', 'false');
        hlBtn.textContent = 'Show all ' + hlItems.length + ' features';
        hlBtn.addEventListener('click', function () {
          var o = hl.classList.toggle('is-short') === false;
          hlBtn.setAttribute('aria-expanded', o ? 'true' : 'false');
          hlBtn.textContent = o ? 'Show fewer' : 'Show all ' + hlItems.length + ' features';
        });
        hl.appendChild(hlBtn);
      }
    }

    /* ---------------- section nav: sticky, marks where you are ---------------- */
    var dnav = section.querySelector('.aaa-details__nav');
    if (dnav) {
      var dlinks = Array.prototype.slice.call(dnav.querySelectorAll('a[href^="#"]'));
      var dtargets = dlinks.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); });
      var spy = function () {
        var line = dnav.getBoundingClientRect().bottom + 24, cur = -1;
        dtargets.forEach(function (t, i) { if (t && t.getBoundingClientRect().top <= line) cur = i; });
        if (cur < 0) cur = 0; // before the details, the first tab reads as where the details start
        dlinks.forEach(function (a, i) { a.classList.toggle('is-active', i === cur); if (i === cur) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
        dnav.classList.toggle('is-stuck', dnav.getBoundingClientRect().top <= 0.5);
      };
      var spyQueued = false;
      window.addEventListener('scroll', function () { if (spyQueued) return; spyQueued = true; requestAnimationFrame(function () { spyQueued = false; spy(); }); }, { passive: true });
      spy();
    }

    var prose = section.querySelector('[data-aaa-clamp]');
    var more = section.querySelector('[data-aaa-more]');
    if (prose && more) {
      // Cut at the end of a whole paragraph (no half-lines under a fade).
      var measure = function () {
        if (prose.dataset.aaaOpen === '1') return;
        prose.classList.remove('is-clamped');
        prose.style.maxHeight = '';
        // Desktop: the overview runs as long as the specs beside it, so neither
        // column ends on a blank rectangle. Phone: a fixed cut.
        var limit = 420;
        var prim = section.querySelector('.aaa-details__primary');
        var sec = section.querySelector('.aaa-details__secondary');
        if (prim && sec && window.innerWidth >= 990) {
          var slack = sec.offsetHeight - prim.offsetHeight;
          if (slack >= -40) { more.hidden = true; balance(); return; }
          limit = Math.max(420, prose.scrollHeight + slack);
        }
        if (prose.scrollHeight <= limit + 140) { more.hidden = true; balance(); return; }
        var top = prose.getBoundingClientRect().top, cut = 0;
        Array.prototype.some.call(prose.children, function (el) {
          var b = el.getBoundingClientRect().bottom - top;
          if (b > limit && cut > 0) return true;
          cut = b;
          return b > limit;
        });
        if (!cut || cut >= prose.scrollHeight - 40) { more.hidden = true; return; }
        prose.style.maxHeight = Math.ceil(cut) + 'px';
        prose.classList.add('is-clamped');
        more.hidden = false;
        balance();
      };
      measure();
      window.addEventListener('load', measure, { once: true });
      var rz; window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(measure, 200); });
      more.addEventListener('click', function () {
        var open = prose.dataset.aaaOpen === '1';
        prose.dataset.aaaOpen = open ? '0' : '1';
        prose.classList.toggle('is-clamped', open);
        if (open) measure(); else { prose.style.maxHeight = ''; balance(); }
        more.setAttribute('aria-expanded', open ? 'false' : 'true');
        more.textContent = open ? 'Read the full description' : 'Show less';
        if (open) prose.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    }

    /* ---------------- desktop photo grid: the rest on request ---------------- */
    var gridMore = section.querySelector('[data-aaa-grid-more]');
    if (gridMore && media) {
      gridMore.addEventListener('click', function () {
        var open = !media.classList.contains('is-all');
        media.classList.toggle('is-all', open);
        gridMore.setAttribute('aria-expanded', open ? 'true' : 'false');
        gridMore.textContent = open ? 'Show fewer photos' : 'Show all ' + wrappers.length + ' photos';
        if (!open) media.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    }

    /* ---------------- mobile sticky add-to-cart ---------------- */
    var atc = section.querySelector('button.add-to-cart[id^="addToCart-"]');
    if (atc) {
      // A scroll check, not an IntersectionObserver: a jump from below the
      // button to above it (anchor link, scroll restore) crosses no threshold.
      var ticking = false;
      var check = function () {
        ticking = false;
        var r = atc.getBoundingClientRect();
        // Only once the real button has scrolled up out of view. Before the
        // shopper reaches it the bar stays away, so it never sits over the
        // variant chips and price above the button; the real button and the
        // picker are always the first buy action. Docked to the viewport bottom.
        document.documentElement.classList.toggle('aaa-sticky-on', r.height > 0 && r.bottom < 0);
      };
      var queue = function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } };
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      check();
    }

    /* sticky bar names the choice, not a truncated product title:
       a variant's own title ("Green / 4P"), or the range size ("Dometic CFX5 · 55") */
    var stickyTitle = document.querySelector('.mobile-sticky-atc__title');
    function paintSticky() {
      if (!stickyTitle) return;
      var v = selectedVariant();
      var label = '';
      if (v && variants.length > 1 && v.title && v.title !== 'Default Title') label = v.title;
      else {
        var cur = section.querySelector('.aaa-range__chip.is-current .aaa-range__size');
        var hint = section.querySelector('.aaa-range__hint');
        var rl = section.querySelector('.aaa-range__label');
        if (cur && hint && rl && /^\s*Size/.test(rl.textContent)) label = hint.textContent.replace(/\s*range\s*$/, '').trim() + ' \u00b7 ' + cur.textContent.trim();
      }
      if (label) { stickyTitle.textContent = label; stickyTitle.classList.add('is-choice'); }
    }
    paintSticky();
    document.addEventListener('aaa:variant', function () { setTimeout(paintSticky, 0); });
    if (idSelect) idSelect.addEventListener('change', function () { setTimeout(paintSticky, 0); });

    if (!prose || !more) { balance(); window.addEventListener('load', balance, { once: true }); }

    /* ---------------- no reviews yet: Loox's form on demand ---------------- */
    Array.prototype.forEach.call(section.querySelectorAll('[data-aaa-review-write]'), function (btn) {
      var w = document.getElementById('looxReviews');
      if (!w) return;
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') !== 'true';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        w.classList.toggle('is-open', open);
        if (open) w.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest' });
      });
    });

    /* ---------------- express checkout: one tap away ---------------- */
    Array.prototype.forEach.call(section.querySelectorAll('[data-aaa-express]'), function (x) {
      var t = x.querySelector('.aaa-express__toggle'), p = x.querySelector('.aaa-express__panel');
      if (!t || !p) return;
      t.addEventListener('click', function () {
        var open = t.getAttribute('aria-expanded') !== 'true';
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
        x.classList.toggle('is-open', open);
        if (open) p.removeAttribute('inert'); else p.setAttribute('inert', '');
      });
    });

    /* ---------------- dispatch: one calm line, the route on request ----------------
       stock-status.liquid draws a supplier -> warehouse -> you diagram. In the
       buy box that made the lead time the loudest thing on the page, so the
       card is summarised to its status plus the lead-time note, and the
       diagram opens from a "How it ships" toggle. */
    var ss = section.querySelector('#sp-stock-status');
    var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var MONS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    function addBiz(n) {
      var d = new Date(); d.setHours(12, 0, 0, 0);
      while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; }
      return d;
    }
    function fmtDay(d) { return DAYS[d.getDay()] + ' ' + d.getDate() + ' ' + MONS[d.getMonth()]; }
    // "allow 10-12 business days from supplier" -> "Fri 31 Oct – Tue 4 Nov"
    function dateWindow(note) {
      var m = /(\d{1,2})\s*(?:-|–|to)\s*(\d{1,2})\s*business\s+days/i.exec(note) || /(\d{1,2})\s*business\s+days/i.exec(note);
      if (!m) return '';
      var a = +m[1], b = m[2] ? +m[2] : a;
      if (!a || b > 40 || b < a) return '';
      return a === b ? fmtDay(addBiz(a)) : fmtDay(addBiz(a)) + ' – ' + fmtDay(addBiz(b));
    }
    // the stock word follows the add-to-cart state, so a sold-out or
    // pre-order variant never reads "In stock"
    function noStockOnHand() {
      var P = window.product; var idEl = idSelect || section.querySelector('form[action*="/cart/add"] [name="id"]'); var id = idEl && idEl.value;
      if (!P || !id || !P.tracked || !P.tracked[id] || !P.inventory || !P.policy) return false;
      return P.inventory[id] <= 0 && P.policy[id] === 'continue';
    }
    function paintStock() {
      if (!ss) return; // no ship-planner stock card on this template
      var el = ss.querySelector('.aaa-stock');
      if (!el) return;
      var st = el.getAttribute('data-aaa-stock');
      var lbl = atcBtn ? (atcBtn.textContent || '').trim().toLowerCase() : '';
      var state = 'in', word = 'In stock';
      if (atcBtn && atcBtn.disabled) { state = 'out'; word = 'Sold out'; }
      else if (/pre-?order/.test(lbl) || st === 'on_order') { state = 'pre'; word = st === 'on_order' ? 'On order' : 'Pre-order'; }
      // supplier-shipped and sold at zero stock (continue-selling): orderable, but we can't say 'In stock'.
      // A 'warehouse' card is ship-planner's own in-stock answer, so it keeps the word.
      else if (st !== 'warehouse' && noStockOnHand()) { state = 'pre'; word = 'Available to order'; }
      el.className = 'aaa-stock is-' + state;
      el.textContent = word;
      ss.classList.toggle('is-soldout', state === 'out');
    }
    document.addEventListener('aaa:variant', function () { setTimeout(paintStock, 0); });
    if (ss) {
      var tidy = function () {
        var card = ss.querySelector('.ss-card');
        if (!card || card.querySelector('.aaa-ss-sum')) return;
        var st = card.querySelector('.ss-status');
        var j = card.querySelector('.ss-journey');
        var notes = Array.prototype.map.call(card.querySelectorAll('.ss-node-note'), function (n) { return n.textContent.replace(/^\(|\)$/g, '').trim(); }).filter(Boolean);
        var sum = document.createElement('div');
        sum.className = 'aaa-ss-sum';
        var line = document.createElement('p');
        line.className = 'aaa-ss-line';
        line.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>';
        var txt = document.createElement('span');
        txt.innerHTML = '<strong></strong>';
        // "from our supplier" says drop-ship and nothing the shopper can use
        txt.firstChild.textContent = st ? st.textContent.replace(/\s+[—-]\s+/, ', ').replace(/^\s*Ships direct from our supplier/i, 'Ships direct to your door').replace(/^\s*In stock,\s*ships/i, 'Ships') : ''; // the stock word above already says "In stock"
        // one promise, not two: when the lead time becomes a dated window the
        // raw "allow 10-12 business days" note it came from is not repeated
        var winFirst = notes.length ? dateWindow(notes[0]) : '';
        if (notes.length && !winFirst) { var n = document.createElement('span'); n.className = 'aaa-ss-note'; n.textContent = notes[0].charAt(0).toUpperCase() + notes[0].slice(1); txt.appendChild(n); }
        line.appendChild(txt);
        sum.appendChild(line);
        // stock + a dated window, from the same lead time the note gives
        var stock = document.createElement('p');
        stock.className = 'aaa-stock';
        stock.setAttribute('data-aaa-stock', card.className.replace(/.*ss-card--([a-z_]+).*/, '$1'));
        sum.insertBefore(stock, line);
        var win = notes.length ? dateWindow(notes[0]) : '';
        if (win) {
          var nEl = txt.querySelector('.aaa-ss-note');
          var w = document.createElement('span');
          w.className = 'aaa-ss-when';
          w.innerHTML = 'Expected to ship <strong></strong>';
          w.lastChild.textContent = win;
          if (nEl) txt.insertBefore(w, nEl); else txt.appendChild(w);
        }
        if (j) {
          var tg = document.createElement('button');
          tg.type = 'button'; tg.className = 'aaa-ss-toggle'; tg.setAttribute('aria-expanded', 'false');
          tg.textContent = 'How it ships';
          tg.addEventListener('click', function () {
            var o = !card.classList.contains('is-route');
            card.classList.toggle('is-route', o);
            tg.setAttribute('aria-expanded', o ? 'true' : 'false');
          });
          line.appendChild(tg);
        }
        card.insertBefore(sum, card.firstChild);
        card.classList.add('aaa-ss');
        paintStock();
      };
      tidy();
      new MutationObserver(tidy).observe(ss, { childList: true, subtree: false });
    }

    /* ---------------- desktop detail grid: a tile shows in the stage ---------------- */
    if (media) {
      media.addEventListener('click', function (e) {
        if (!e.target.closest || !e.target.closest('.aaa-thumb')) return;
        var stage = media.querySelector('.aaa-stage');
        if (!stage) return;
        var r = stage.getBoundingClientRect();
        if (r.top < 60) window.scrollBy({ top: r.top - 90, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    }
  }

  /* product video titles are built as "<vendor> <title>", and most titles already
     open with the vendor ("Vango Vango Tahoe 400"): drop the repeat once injected */
  function dedupeVideoTitle() {
    Array.prototype.forEach.call(document.querySelectorAll('.aaa-pdp .product-video-title, .aaa-pdp .product-video-wrapper iframe'), function (el) {
      var attr = el.tagName === 'IFRAME';
      var t = attr ? el.getAttribute('title') : el.textContent;
      if (!t) return;
      var fixed = t.replace(/^(\S+)\s+\1\s+/i, '$1 ');
      if (fixed === t) return;
      if (attr) el.setAttribute('title', fixed); else el.textContent = fixed;
    });
  }
  window.addEventListener('load', function () { dedupeVideoTitle(); setTimeout(dedupeVideoTitle, 2500); });

  /* in-page links (rating, "All specifications", details nav) */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-aaa-scroll]');
    if (!a) return;
    var id = (a.getAttribute('href') || '').replace(/^#/, '');
    var el = id && document.getElementById(id);
    if (!el) return;
    e.preventDefault();
    var details = el.closest && el.closest('details');
    if (details) details.open = true;
    el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  });

  /* ---- rails: grid when it fits, arrows only when it scrolls ---------- */
  function initRails(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-aaa-rail]'), function (rail) {
      if (rail.__aaa) return; rail.__aaa = true;
      var track = rail.querySelector('[data-aaa-rail-track]');
      var nav = rail.querySelector('.aaa-rail__nav');
      var prev = rail.querySelector('[data-aaa-rail-prev]');
      var next = rail.querySelector('[data-aaa-rail-next]');
      if (!track || !nav) return;
      function update() {
        var over = track.scrollWidth - track.clientWidth > 4;
        nav.hidden = !over;
        rail.classList.toggle('is-scrolling', over);
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      }
      function step(dir) {
        var card = track.querySelector('.aaa-card');
        var w = card ? card.getBoundingClientRect().width + 16 : 240;
        track.scrollBy({ left: dir * w * Math.max(1, Math.floor(track.clientWidth / w) - 1), behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---- one-tap add from a rail card ------------------------------------ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-aaa-quick-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var id = btn.getAttribute('data-aaa-quick-add');
    var label = btn.querySelector('[data-aaa-add-label]');
    btn.disabled = true;
    function done(ok) {
      if (ok) { btn.classList.add('is-added'); if (label) label.textContent = 'Added'; }
      setTimeout(function () { btn.classList.remove('is-added'); if (label) label.textContent = 'Add'; btn.disabled = false; }, ok ? 2200 : 0);
    }
    if (window.modernCart && typeof window.modernCart.add === 'function') {
      window.modernCart.add({ variantId: id, quantity: 1, openDrawer: false }).then(function (added) { done(!!added); }, function () { done(false); });
      return;
    }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 }) })
      .then(function (r) { if (!r.ok) throw 0; return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var c = document.querySelector('.fc-cart + span');
        if (c) { c.textContent = cart.item_count; c.classList.toggle('hidden-count', cart.item_count === 0); }
        done(true);
      })
      .catch(function () { done(false); });
  });

  /* ---- Shopify Inbox chat ----------------------------------------------
     The floating launcher sat over the price and Afterpay line on a phone
     and over the payment buttons on desktop. On product pages it waits:
     hidden on a phone or tablet (the buy box has a "chat with us" link),
     hidden on desktop while the buy box is on screen. Opening the chat
     from the link shows it for the rest of the visit. */
  function initChat() {
    var root = document.documentElement;
    var buy = document.querySelector('.aaa-pdp__buy');
    if (!buy || root.__aaaChat) return;
    root.__aaaChat = true;
    var phone = window.matchMedia('(max-width: 989px)');
    var buyVisible = true;
    function apply() {
      if (root.classList.contains('aaa-chat-open')) { root.classList.remove('aaa-chat-wait'); return; }
      root.classList.toggle('aaa-chat-wait', phone.matches || buyVisible);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { buyVisible = es[0].isIntersecting; apply(); }, { rootMargin: '0px 0px -120px 0px' }).observe(buy);
    }
    if (phone.addEventListener) phone.addEventListener('change', apply);
    apply();
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-aaa-chat]');
      if (!t) return;
      e.preventDefault();
      var chat = document.querySelector('shopify-chat');
      root.classList.add('aaa-chat-open');
      apply();
      // show() opens the panel; 'open' is a reflected attribute, not a method
      if (chat && typeof chat.show === 'function') { try { chat.show(); return; } catch (err) {} }
      if (chat) { chat.setAttribute('open', ''); return; }
      window.location.href = '/pages/contact-us';
    });
  }

  /* ---- reviews: show the first screenful, then "Show more reviews" ---- */
  function initReviewClip() {
    var clip = document.querySelector('[data-aaa-clip]');
    var more = document.querySelector('[data-aaa-clip-more]');
    if (!clip || !more || clip.__aaa) return;
    clip.__aaa = true;
    var open = false;
    var opener = document.querySelector('[data-aaa-reviews-open]');
    function limit() { return window.innerWidth < 769 ? 960 : 640; }
    function update() {
      if (open || clip.hasAttribute('data-aaa-collapsed')) { if (!open) more.hidden = true; return; }
      var tall = clip.scrollHeight > limit() + 120;
      clip.classList.toggle('is-clipped', tall);
      clip.style.maxHeight = tall ? limit() + 'px' : '';
      more.hidden = !tall;
    }
    more.addEventListener('click', function () {
      open = true;
      clip.classList.remove('is-clipped');
      clip.style.maxHeight = '';
      more.hidden = true;
      more.setAttribute('aria-expanded', 'true');
    });
    if (opener) {
      opener.addEventListener('click', function () {
        var collapsed = clip.hasAttribute('data-aaa-collapsed');
        if (collapsed) {
          clip.removeAttribute('data-aaa-collapsed');
          clip.classList.remove('is-collapsed');
          opener.setAttribute('aria-expanded', 'true');
          opener.classList.add('is-open');
          update();
        } else {
          open = false;
          clip.setAttribute('data-aaa-collapsed', '');
          clip.classList.add('is-collapsed');
          clip.classList.remove('is-clipped');
          clip.style.maxHeight = '';
          more.hidden = true;
          more.setAttribute('aria-expanded', 'false');
          opener.setAttribute('aria-expanded', 'false');
          opener.classList.remove('is-open');
        }
      });
    }
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(document.getElementById('looxReviews') || clip.firstElementChild || clip);
    window.addEventListener('load', update);
    update();
  }

  /* ---- shipping calculator inline: open, postcode-first, remembered ----
     The ship-planner app draws a collapsed "Calculate Shipping" accordion.
     Open it once so the postcode field sits in the buy box, and when the
     shopper has entered a postcode before (this browser only), run the
     quote for them so the delivery cost just shows. */
  function initShipCalc() {
    var KEY = 'aaa:postcode';
    function get() { try { return localStorage.getItem(KEY) || ''; } catch (e) { return ''; } }
    function put(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
    var tries = 0;
    (function wait() {
      var root = document.getElementById('ship-planner-root');
      var head = root && root.querySelector('.ship-planner-header');
      if (!head) { if (++tries < 40) setTimeout(wait, 250); return; }
      if (root.__aaa) return; root.__aaa = true;
      root.classList.add('aaa-shipcalc');
      // The calculator sits inside the product form. Its postcode field's 'change' (fired on blur)
      // bubbled to the form, the Afterpay line re-rendered and the page jumped ~30px between
      // mousedown and mouseup, so a click on Calculate missed the button. Keep it to itself.
      root.addEventListener('change', function (e) { e.stopPropagation(); });
      if (!root.querySelector('.ship-planner-content')) head.click();
      var t2 = 0;
      (function fill() {
        var form = root.querySelector('.ship-planner-form');
        if (!form) { if (++t2 < 20) setTimeout(fill, 150); return; }
        var pc = form.querySelector('input[type="text"]');
        if (pc) {
          pc.setAttribute('inputmode', 'numeric');
          pc.setAttribute('autocomplete', 'postal-code');
          pc.setAttribute('aria-label', 'Postcode');
          pc.setAttribute('maxlength', '4');
        }
        form.addEventListener('submit', function () { if (pc && /^\d{4}$/.test(pc.value)) put(pc.value); }, true);
        var saved = get();
        if (pc && /^\d{4}$/.test(saved) && !pc.value) {
          var setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
          setter.call(pc, saved);
          pc.dispatchEvent(new Event('input', { bubbles: true }));
          setTimeout(function () { var b = form.querySelector('button[type="submit"]'); if (b) b.click(); }, 60);
        }
      })();
    })();
  }

  function boot() {
    initShipCalc();
    Array.prototype.forEach.call(document.querySelectorAll('.aaa-pdp[data-section-type="product"]'), initSection);
    initRails(document);
    initChat();
    initReviewClip();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.aaa-pdp[data-section-type="product"]');
    if (s) initSection(s);
  });
})();
